const { createElement, useEffect, useRef } = require("react");
export interface DangerouslySetHtmlContentProps {
  html: any;
  dangerouslySetInnerHTML?: any;
  allowRerender?: boolean;
  className?: string;
}

function DangerouslySetHtmlContent({
  html,
  dangerouslySetInnerHTML,
  allowRerender,
  className = "",
  ...rest
}: DangerouslySetHtmlContentProps) {
  // We remove 'dangerouslySetInnerHTML' from props passed to the div
  const divRef = useRef(null);
  const isFirstRender = useRef(true);
  // const rasRendered = useRef(false);

  useEffect(() => {
    try {
      if (!html || !divRef.current) throw new Error("html prop can't be null");
    } catch (e) {
      console.log("Error: ", e, html);
    }

    if (!isFirstRender.current) return;
    isFirstRender.current = Boolean(allowRerender);

    const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
    divRef.current.innerHTML = ""; // Clear the container

    divRef.current.appendChild(slotHtml); // Append the new content
  }, [html, divRef]);

  // useEffect(() => {
  //   if (!rasRendered.current) {
  //     if (document?.getElementById("ras-content")) {
  //       if (window?.loadSidebar) {
  //         try {
  //           const res = window?.loadSidebar(
  //             document.getElementById("ras-content")
  //           );
  //           console.log("res:", res);
  //           rasRendered.current = true;
  //         } catch (e) {
  //           console.log("Ras error: ", e);
  //         }
  //       } else {
  //         setTimeout(() => {
  //           try {
  //             const res = window?.loadSidebar(
  //               document.getElementById("ras-content")
  //             );
  //             console.log("res2:", res);
  //           } catch (e) {
  //             console.log("res timeout error: ", e);
  //           }
  //         }, 1000);
  //       }
  //     }
  //   }
  // }, [
  //   html,
  //   divRef,
  //   rasRendered.current,
  //   isFirstRender.current,
  //   divRef.current,
  // ]);

  return createElement("div", { ...rest, className, ref: divRef });
}

export default DangerouslySetHtmlContent;
